<template>
  <div>
    <div class="container text-left">
      <div>
        <b-button
            variant="primary"
            size="sm"
            class="mb-1"
            @click="$router.go(-1)"
        >Zurück zu Dateneingabe und Optionsauswahl</b-button>
      </div>

      <h2 class="h3 steps-title ">
        Bitte überprüfen Sie die Bestellzusammenfassung:
      </h2>

      <address-summary/>

      <b-card>
        <product-summary/>
        <hr>
        <p><strong>Die Berechnung der ausgewählten Leistungen erfolgt mit erbrachter Leistung bzw. auf Basis des
          Leistungszeitraums.</strong></p>
        <p>Sollte die technische Realisierung nicht möglich sein, kommt dieser Vertrag nicht zustande und es entstehen
          dem Kunden bei Cable 4 keinerlei Kosten.
          Cable 4 behält sich vor, eine Realisierung ohne Angabe von Gründen abzulehnen. Der Anschlussnehmer erkennt die
          AGB für die einzelnen Dienste sowie
          die Hinweise zur Datenverarbeitung, zur Bonitätsprüfung und zum Widerrufsrecht an</p>
      </b-card>

      <b-card title="Gewünschter Vertragsbeginn">
        <span v-if="CHECKOUT_DATA.appointment == 1">
          Schnellstmöglich
        </span>
        <span v-if="CHECKOUT_DATA.appointment == 2">
          {{ formatDate(CHECKOUT_DATA.appointment_date) }}
        </span>
        <span v-if="CHECKOUT_DATA.appointment == 3">
          Direkt nach Vertragsende beim jetzigen Anbieter (keine doppelten Kosten)
        </span>
      </b-card>

      <b-card title="Telefonanschluss" v-if="getOptionList('phoneOption').length > 0 || getOptionList('phoneOptions').length > 0">
        <div>
          <p v-if="CHECKOUT_DATA.phoneline.option == 1">
            <strong>Anschlussart: </strong> Neuanschluss
          </p>
          <div v-if="CHECKOUT_DATA.phoneline.option == 2">
            <p>Sie haben Ihren bisherigen Anschluss bereits gekündigt.</p>
            <p>
              <strong>Bisheriger Anbieter: </strong>
              <template v-if="CHECKOUT_DATA.phoneline.provider.value === 'other'">
                {{ CHECKOUT_DATA.phoneline.provider_other }}
              </template>
              <template v-else>
                {{ CHECKOUT_DATA.phoneline.provider.label }}
              </template>
              <br/>
              <strong>Kündigungsdatum: </strong> {{ formatDate(CHECKOUT_DATA.phoneline.termination_date) }}
            </p>
          </div>
          <div v-if="CHECKOUT_DATA.phoneline.option == 3">
            <p>
              Sie möchten, dass Cable 4 Ihren Anschluss beim alten Anbieter kündigt und Ihre Rufnummern kostenlos
              übernimmt.</p>
            <div>
              <strong>Bisheriger Anbieter: </strong> {{ CHECKOUT_DATA.phoneline.provider.label }}
            </div>
            <div v-if="CHECKOUT_DATA.phoneline.owner_firstname || CHECKOUT_DATA.phoneline.owner_name">
              <strong>Bisheriger Anschlussinhaber: </strong>
              {{ CHECKOUT_DATA.phoneline.owner_firstname }}
              {{ CHECKOUT_DATA.phoneline.owner_name }}
            </div>
          </div>
          <div v-if="CHECKOUT_DATA.transfer_phonenumer">
            <dl class="row">
              <dt class="col-sm-4">
                <strong>Zu übernehmende Rufnummern:</strong>
              </dt>
              <dd class="col-sm-8">
                <ul class="list-unstyled">
                  <li v-for="(item, index) in CHECKOUT_DATA.phoneline.numbers" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </dd>
            </dl>
          </div>
        </div>
        <hr>
        <b-row>
          <b-col md="12">
            <!--            <div>-->
            <!--              <strong>Neue Rufnummern: </strong>-->
            <!--              <template v-if="CHECKOUT_DATA.phoneline.new_numbers">-->
            <!--                Ja (Anzahl: 1)-->
            <!--              </template>-->
            <!--              <template v-else>Nein</template>-->
            <!--            </div>-->
            <div v-if="CHECKOUT_DATA.transfer_phonenumer && false" class="mt-1">
              <strong>Zu übernehmende Rufnummern: </strong>
              <div v-for="index in 6" :key="index">
                <template v-if="CHECKOUT_DATA.phoneline.numbers[index]">
                  {{ CHECKOUT_DATA.phoneline.numbers[index] }}
                </template>
              </div>
            </div>
            <div  class="mt-1">
              <strong>Einzelverbindungsnachweis: </strong>
              <template v-if="CHECKOUT_DATA.itemization">
                Ja - Format:
                <template v-if="CHECKOUT_DATA.itemization_type == 'short'">
                  Gekürzt (z. B. 030-123456XXX)
                </template>
                <template v-else>
                  Ungekürzt (z. B. 030-123456789)
                </template>
              </template>
              <template v-else>Nein</template>
            </div>
            <div class="d-flex" v-if="this.CHECKOUT_DATA.phoneline.phonebook[0].selected">
              <strong class="">Telefonbucheintrag:&nbsp;</strong>
              <template v-if="hasPhonebookEntries">
                <span class="d-inline-block" v-if="this.CHECKOUT_DATA.phoneline.phonebook[0].selected">
                  <ol>
                    <li :class="{'pt-1': entry.index > 0}" v-for="entry in this.CHECKOUT_DATA.phoneline.phonebook"
                        :key="entry.index" v-if="entry.selected">
                        <strong>Eintrag in das gedruckte Telefonbuch: </strong>
                        {{ entry.print_entry ? 'Ja' : 'Nein' }}<br/>
                        <strong>Eintrag in die elektronischen Auskunftsmedien: </strong>
                        {{ entry.electronic_entry ? 'Ja' : 'Nein' }}<br/>
                        <strong>Eintrag bei der telefonischen Auskunft: </strong>
                        {{ entry.phone_entry ? 'Ja' : 'Nein' }}<br/>
                        <strong>Widerspruch der Rückwärts-/Inverssuche: </strong>
                        {{ entry.rejectinverse_entry ? 'Ja' : 'Nein' }}<br/>
                        <hr>
                      <!--                        <strong>Telefonnummer: </strong> {{ entry.phone }}<br/>-->

                      <!--                        <hr>-->
                        <div class="">
                          <strong>Kontaktdaten:</strong> <br/>
                          <template v-if="entry.firm">
                            {{ entry.firm }} <br/>
                          </template>
                          {{ entry.firstname }} {{ entry.name }} <br/>
                          {{ entry.street }} {{ entry.housenumber }} <br/>
                          {{ entry.postcode }} {{ entry.city }}
                        </div>
                    </li>
                  </ol>
                </span>
              </template>
              <template v-else>
                Nein
              </template>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card title="Anschluss" v-else>
        <p v-if="CHECKOUT_DATA.phoneline.option == 1">
          <strong>Anschlussart: </strong> Neuanschluss
        </p>
        <div v-if="CHECKOUT_DATA.phoneline.option == 2">
          <p>Sie haben Ihren bisherigen Anschluss bereits gekündigt.</p>
          <p>
            <strong>Bisheriger Anbieter: </strong>
            <template v-if="CHECKOUT_DATA.phoneline.provider.value === 'other'">
              {{ CHECKOUT_DATA.phoneline.provider_other }}
            </template>
            <template v-else>
              {{ CHECKOUT_DATA.phoneline.provider.label }}
            </template>
            <br/>
            <strong>Kündigungsdatum: </strong> {{ formatDate(CHECKOUT_DATA.phoneline.termination_date) }}
          </p>
        </div>
        <div v-if="CHECKOUT_DATA.phoneline.option == 3">
          <p>
            Sie möchten, dass Cable 4 Ihren Anschluss beim alten Anbieter kündigt und Ihre Rufnummern kostenlos
            übernimmt.</p>
          <div>
            <strong>Bisheriger Anbieter: </strong> {{ CHECKOUT_DATA.phoneline.provider.label }}
          </div>
          <div v-if="CHECKOUT_DATA.phoneline.owner_firstname || CHECKOUT_DATA.phoneline.owner_name">
            <strong>Bisheriger Anschlussinhaber: </strong>
            {{ CHECKOUT_DATA.phoneline.owner_firstname }}
            {{ CHECKOUT_DATA.phoneline.owner_name }}
          </div>
        </div>
      </b-card>

      <b-card title="Ihre Anmerkung zur Bestellung" v-if="CHECKOUT_DATA.comment && CHECKOUT_DATA.comment.trim() != ''">
        <p>{{ CHECKOUT_DATA.comment }}</p>
      </b-card>



      <configuration-submit-order />
    </div>
  </div>
</template>

<script>

import ProductSummary from "@/views/checkout/summary/ProductSummary";
import AddressSummary from "@/views/checkout/summary/AddressSummary";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, email, digits} from '@validations'

import {
  BCard,
  BCol,
  BRow,
  BForm,
  BButton, BModal,
} from "bootstrap-vue";
import {mapGetters} from "vuex";
import ServiceOptionItemText from "@/components/ServiceOptionItemText";
import pdf from 'vue-pdf'
import CheckoutSubmitOrder from "@/views/checkout/CheckoutSubmitOrder.vue";
import ConfigurationSubmitOrder from "@/views/checkout/configuration/ConfigurationSubmitOrder.vue";

export default {
  name: "CheckoutSummary",
  components: {
    AddressSummary,
    ProductSummary,
    BCard,
    BRow,
    BCol,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    ServiceOptionItemText,
    pdf,
    BModal,
    CheckoutSubmitOrder,
    ConfigurationSubmitOrder
  },
  data() {
    return {
      load_order_summary: false,
      terms_and_conditions: false,
      privacy: false,
      order_summary_downloaded: false,
      order_summary_received: false,
      revocation: false,
      file: null,
      fileUrl: null,
      fileName: null,
      pdf: null,
      numPages: 0,
      pdfString: null,
      pdfIsSaved: false,
    }
  },
  computed: {
    ...mapGetters(['PRODUCT_ADDRESS', 'SERVICE', 'CHECKOUT_DATA', 'ORDER_STEPS_CURRENT', 'ORDER_STEPS_TOTAL', 'IS_EMPLOYEE', 'CAPTURE_METHOD']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    formatDate(datestring) {
      let options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      };
      let date = new Date(datestring)

      return date.toLocaleDateString('de-DE', options)
    },
    hasPhonebookEntries() {
      let entries = this.CHECKOUT_DATA.phoneline.phonebook.filter(entry => entry.selected)

      return entries.length > 0
    },
    downloadSummary() {
      this.load_order_summary = true

      if (this.order_summary_downloaded) {
        this.load_order_summary = false
        this.loadPdfAndOpenModal()
        return;

        let link = document.createElement('a');
        // create a blobURI pointing to our Blob
        link.href = URL.createObjectURL(this.file);
        link.download = this.fileName;
        // some browser needs the anchor to be in the doc
        document.body.append(link);
        link.click();
        link.remove();

        this.load_order_summary = false
        return;
      }

      let data = {
        id: this.SERVICE.id,
        tenant: this.SERVICE.tenant,
        paperInvoice: this.CHECKOUT_DATA.invoice_paper,
        items: [],
        service: this.SERVICE,
        serviceOptions: [ ...this.CHECKOUT_DATA.serviceOptions ],
        address: this.PRODUCT_ADDRESS
      }

      if (this.CHECKOUT_DATA.appointment == 2) {
        data.appointment_date = this.CHECKOUT_DATA.appointment_date
      }

      this.SERVICE.serviceItems.forEach(item => {
        data.items.push(item)
      })

      this.CHECKOUT_DATA.serviceOptions.forEach(item => {
        data.items.push(item.item)
      })

      if (this.CHECKOUT_DATA.hardwareOptions.length !== 0) {
        data.serviceOptions.push(this.CHECKOUT_DATA.hardwareOptions)
      }

      this.$http.post('/order/summary', data).then(response => {
        let byteCharacters = atob(response.data.pdf);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        // this.pdf = 'data:application/pdf;base64,'+response.data.pdf
        this.pdfString = response.data.pdf
        this.loadPdfAndOpenModal()

        this.file = new Blob([byteArray], {type: 'application/pdf;base64'});
        this.fileURL = URL.createObjectURL(this.file);
        this.fileName = response.data.id + '.pdf';

        this.load_order_summary = false
        this.order_summary_downloaded = true
      })
    },
    loadPdfAndOpenModal() {
      this.pdf = pdf.createLoadingTask('data:application/pdf;base64,'+this.pdfString);

      this.pdf.promise.then(pdf => {
        this.numPages = pdf.numPages;
        this.$bvModal.show('pdf-preview')
      });
    },
    savePdf() {
      if (this.order_summary_downloaded) {
        this.pdfIsSaved = true
        let link = document.createElement('a');
        // create a blobURI pointing to our Blob
        link.href = URL.createObjectURL(this.file);
        link.download = this.fileName;
        // some browser needs the anchor to be in the doc
        document.body.append(link);
        link.click();
        link.remove();
      }
    },
    validateData() {
      this.$router.push({name: 'Checkout Submit Order'})
    },
    getProductDependency(id) {
      for (let _productDependency of this.SERVICE.serviceOptionsDependencies) {
        if (_productDependency.id == id) {
          return _productDependency
        }
      }
    },
    getOptionList(model) {
      const options = this.CHECKOUT_DATA[model] || {}
      return Object.keys(options).reduce((acc, key) => acc.concat(options[key]), [])
    },
  },
  mounted() {
  },
  beforeMount() {
    if (!this.SERVICE || !this.CHECKOUT_DATA) {
      this.$router.push({name: 'orders-add'})
    }
    this.$store.commit('SET_ORDER_STEPS_CURRENT', 2)
  }
}
</script>

<style lang="scss">
.modal-body {
  max-height: 60vh;
}
@media(max-width: 767px) {
  .btn-block-sm-only {
    display: block;
    width: 100%;
  }
}
.modal.fade {
  opacity: 1 !important;
}
</style>
